import { render } from "./ThreadCreate.vue?vue&type=template&id=f2a03866"
import script from "./ThreadCreate.vue?vue&type=script&lang=js"
export * from "./ThreadCreate.vue?vue&type=script&lang=js"
script.render = render

export default script